/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import classNames from 'classnames';
import SelectMenu from '#components/pages/Models/Model/sections/support/forms/SelectMenu/index.js';

const items = [
  { id: 'deficient', name: 'Deficient', value: 'deficient' },
  { id: 'average', name: 'Average', value: 'average' },
  { id: 'superior', name: 'Superior', value: 'superior' },
];

type Props = {|
  form: string,
  name: string,
  inputClassName: string,
|};

const StrongColumnWeakBeamSelectMenu = ({
  form,
  name,
  inputClassName,
}: Props): Element<typeof SelectMenu> => (
  <SelectMenu
    form={form}
    items={items}
    id={name}
    name={name}
    inputClassName={classNames('custom-select', inputClassName)}
    includeEmptyOption
  />
);

export default StrongColumnWeakBeamSelectMenu;
